"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VueInjets = void 0;
class VueInjets {
    static install(V, rootModule) {
        V.injets = rootModule;
        V.mixin({
            data() {
                if (!this.$options.$injets)
                    return {};
                if (!this.$options.$injets.module) {
                    console.warn(`[vue-injets] You must specify a context module for this component.`);
                    return {};
                }
                const data = {};
                const $module = rootModule.getModule(this.$options.$injets.module);
                for (let [key, value] of Object.entries(this.$options.$injets.inject)) {
                    data[key] = $module.get(value);
                }
                return data;
            },
            beforeCreate() {
                Object.defineProperty(this, '$injets', {
                    value: this.$options.injets || rootModule,
                    writable: false,
                    configurable: false,
                });
            },
        });
    }
}
exports.VueInjets = VueInjets;
